import React, { useEffect, useState } from 'react';
import SessionCard from './SessionCard';
import { fetchAuth } from '../utils/fetchAuth';
import Loader from './Loader';

const apiUrl = process.env.REACT_APP_API_URL || '';

interface SessionsListProps {
  user?: User | null;
  handleSessionClick?: (session: Session) => void;
}

const SessionsList: React.FC<SessionsListProps> = ({ user, handleSessionClick }) => {
  const [sessions, setSessions] = useState<Session[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const response = await fetchAuth(`${apiUrl}/admin/users/${user?.id}/sessions`);
        if (!response.ok) {
          throw new Error('Erro ao carregar sessões');
        }
        const data: Session[] = await response.json();
        setSessions(data);
      } catch (err: any) {
        setError(err.message || 'Erro desconhecido');
      } finally {
        setLoading(false);
      }
    };

    fetchSessions();
  }, [user?.id]);

  if (loading) return <Loader />;
  if (error) return <div>Erro: {error}</div>;
  if (sessions.length === 0) return <div>Nenhuma sessão encontrada</div>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {sessions.map((session) => (
        <SessionCard
          key={session.id}
          session={session}
          onSessionClick={handleSessionClick || (() => {})}
        />
      ))}
    </div>
  );
};

export default SessionsList;
